import { render, staticRenderFns } from "./logData.vue?vue&type=template&id=16f04d71&"
import script from "./logData.vue?vue&type=script&lang=js&"
export * from "./logData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports